module.exports = require('./helpers/bundle-url').getBundleURL('krNG3') + "logo.7718c6df.svg";